import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "checkbox", "select"];

  connect() {
    this.toggleFields();
    this.checkboxTarget.addEventListener("change", () => this.toggleFields());
  }

  toggleFields() {
    const checked = this.checkboxTarget.checked;
    this.selectTargets.forEach(select => {
      select.disabled = checked;
    });

    if (checked) {
      this.inputTarget.value = "";
    }
  }
}
